import { endOfDay, endOfToday, isBefore, min, startOfDay, startOfMonth, subMonths } from 'date-fns';
import queryString from 'query-string';
import { matchPath } from 'react-router';

import * as types from 'constants/ActionTypes';
import { MONTH } from 'constants/Global';
import { PATH } from 'constants/RoutesConstants';
import { MANUFACTURER_PATH_DASHBOARD, PATH_DASHBOARD } from 'constants/StatisticsConstants';

import { STATISTICS_LOCATION_CHANGE } from 'modules/statistics/actionTypes';

import { tryParse } from 'utils/date';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {{from : string, to: string, period: string}} StatisticPeriodReducer */
/** @type {StatisticPeriodReducer} */
export const initialState = {
  from: startOfMonth(new Date()).toISOString(),
  to: endOfDay(new Date()).toISOString(),
  period: MONTH,
};

/**
 * @param {import('react-router').Location} location
 * @return {Object}
 */
const getFormattedPeriod = location => {
  const search = queryString.parse(location.search);

  let periodTo = endOfToday();

  let parsedTo = tryParse(search.to, { formatOrigin: 'MM/dd/yyyy' });
  if (parsedTo) {
    parsedTo = endOfDay(parsedTo);
    periodTo = min([parsedTo, periodTo]);
  }

  const monthBefore = subMonths(startOfDay(periodTo), 1);

  let searchFrom = monthBefore;
  const parsedFrom = tryParse(search.from, { formatOrigin: 'MM/dd/yyyy' });
  if (parsedFrom) {
    searchFrom = startOfDay(parsedFrom);
  }

  const periodFrom = isBefore(searchFrom, periodTo) ? searchFrom : monthBefore;

  return {
    from: periodFrom.toISOString(),
    to: periodTo.toISOString(),
  };
};

const setPeriod = (_, { payload }) => payload;

/**
 * @param {StatisticPeriodReducer} state
 * @param {import('modules/global/generic.types').LocationChangeAction} action
 * @return {StatisticPeriodReducer}
 */
const onLocationChange = (state, { payload }) => {
  const match = [
    ...(Object.values(PATH_DASHBOARD)),
    ...(Object.values(MANUFACTURER_PATH_DASHBOARD)),
    PATH.SELF_SERVICE_STATS_DASHBOARD,
    PATH.SELF_SERVICE_STATS_DETAILS,
  ].find(path => matchPath(path.path, payload.location.pathname));
  const isMatching = match !== undefined;

  if (payload.isFirstRendering && isMatching) {
    return { ...state, ...getFormattedPeriod(payload.location) };
  }
  return state;
};

export default createReducer(initialState, {
  [STATISTICS_LOCATION_CHANGE]: onLocationChange,
  [types.SET_DEALER_STATISTICS_PERIOD]: setPeriod,
});
